export * from './async-utils'
export * from './PropostaHelper'
export * from './SimNaoOptionsHelper'
export * from './ParceirosUtil'
export * from './FornecedorHelper'
export * from './Validations'
export * from './date'
export * from './ConvertFile'
export * from './OCRUtil'
export * from './CamposObrigatoriosHelper'
export * from './FormElementHelper'
export * from './ApiErrorHelper'
export * from './CpfUtil'
export * from './ConfigCatHelper'
export * from './cookieUtils'
export * from './AuthFlowHelper'
export * from './MagicLinkHelper'

/**
 * Testa se o objeto está vazio
 */
export function isObjectEmpty(obj: any) {
	return Object.keys(obj).length === 0 && obj.constructor === Object
}

export function isNullOrEmpty(value: any, zeroIsNotEmpty = false) {
	return (
		value === null ||
		value === undefined ||
		value === '' ||
		(zeroIsNotEmpty ? false : value === 0) ||
		(Array.isArray(value) && value.length === 0)
	)
}

function hashCode(str: string) {
	// java String#hashCode
	var hash = 0
	for (var i = 0; i < str.length; i++) {
		hash = str.charCodeAt(i) + ((hash << 14) - hash)
	}
	return hash
}

function intToRGB(i: any) {
	var c = (i & 0x00ffffff).toString(16).toUpperCase()

	return '#00000'.substring(1, 6 - c.length) + c
}

export function colorFromString(str: string): string {
	return intToRGB(hashCode(str))
}

export function getFirstLastName(str: string) {
	if (!str) return

	const names = str.split(' ')

	return `${names[0]} ${names[names.length - 1]}`
}

export const objectToQueryString = (initialObj: any) => {
	const reducer =
		(obj: any, parentPrefix = null) =>
		(prev: any, key: any) => {
			const val = obj[key]
			key = encodeURIComponent(key)
			const prefix = parentPrefix ? `${parentPrefix}[${key}]` : key

			if (val == null || typeof val === 'function') {
				prev.push(`${prefix}=`)
				return prev
			}

			if (['number', 'boolean', 'string'].includes(typeof val)) {
				prev.push(`${prefix}=${encodeURIComponent(val)}`)
				return prev
			}

			prev.push(Object.keys(val).reduce(reducer(val, prefix), []).join('&'))
			return prev
		}

	return Object.keys(initialObj).reduce(reducer(initialObj), []).join('&')
}

/**
 * Retorna uma lista de opções a partir de um enum
 * @param enumType
 * @returns
 */
export function EnumToList<T>(enumType: T) {
	const list = []

	for (const key in enumType) {
		if (isNaN(Number(key)) && Object.prototype.hasOwnProperty.call(enumType, key))
			list.push({ value: enumType[key], text: key.replace('_', ' ') })
	}

	return list
}

/**
 * Essa função cria a rotina de download de um file
 * @param file ArrayBuffer obtido no metodo de attaServices.getDownloadFilesAsync
 * return void
 */
export async function forceDownloadFile(file: Blob, fileName: string) {
	let blob = new Blob([file], { type: 'arraybuffer' }) //for overload error
	let url = URL.createObjectURL(blob)
	let link = document.createElement('a')
	link.style.display = 'none'
	link.href = url
	link.setAttribute('download', fileName)
	document.body.appendChild(link)
	link.click()
	document.body.removeChild(link)
}
